import { Component, inject, Signal } from '@angular/core';
import { ProjectLocationComponent } from '@app/shared/components/project-location/project-location.component';
import { LocationsActionsService } from '@app/shared/services/locations-actions.service';
import { Location } from '@app/shared/types/models/location/location.model';
import { UiPageWrapperComponent } from '@app/shared/ui/page-wrapper/ui-page-wrapper.component';
import { UiSpinnerDirective } from '@app/shared/ui/spinner/ui-spinner.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-project-locations-view',
  templateUrl: './project-locations-view.component.html',
  imports: [TranslatePipe, UiPageWrapperComponent, ProjectLocationComponent, UiSpinnerDirective]
})
export class ProjectLocationsViewComponent {
  private readonly locationService: LocationsActionsService = inject(LocationsActionsService);
  protected readonly projectLocations: Signal<Location[]> = this.locationService.getProjectLocations();
}
